import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { QuickAddService } from './quick-add.service';
import { ProjectViewModel } from '../models-views/project.view.model';
import { TaskViewModel } from '../models-views/task.view.model';
import { ClientViewModel } from '../models-views/client.view.model';
import { ConsoleViewModel } from '../models-views/console.view.modal'; 
import { ConsoleTabsetData } from '../models/console.model';

@Injectable({
  providedIn: 'root'
})
export class ConsoleTabService { 
  
  private activeTabs: ConsoleTabsetData[] = [];
  private currentTabIndex: number = 0;
  public tabChangedEvent: Subject<boolean> = new Subject<false>();
  public closeShowMasterSearchEvent: Subject<boolean> = new Subject<false>();

  typeIconList= [
     {type: "client", icon: "apartment"},
    { type: "project", icon: "project"},
    { type: "task", icon: "reconciliation"},
    { type: "event", icon: "calendar"},
  ]
   
 
  constructor(private quickAddservice:QuickAddService,private vm:ConsoleViewModel) {

    if(localStorage.getItem('activeTabs') != null) {
      const localData = localStorage.getItem('activeTabs') || '[]'; 
      const localcurrentTabIndex = localStorage.getItem('currentTab') || '0'; 
      this.activeTabs = JSON.parse(localData);
      this.currentTabIndex = Number(localcurrentTabIndex);
    }
    
  }

  public setActiveTabsToLocal(data: ConsoleTabsetData[]){
    this.activeTabs = data;
    localStorage.setItem('activeTabs', JSON.stringify(data));
  }

  public setCurrentTabToLocal(index: number){
    this.currentTabIndex = index;
    localStorage.setItem('currentTab', JSON.stringify(this.currentTabIndex));
  }
  
  public getActiveTabs(): ConsoleTabsetData[] {
    return this.activeTabs;
  }

  public getCurrentTabIndex(): number {
    return this.currentTabIndex;
  }

  public getCurrentTab(): ConsoleTabsetData {
    return this.activeTabs[this.currentTabIndex];
  }


  public setConsoleTab(data: any, type: 'client' | 'project' | 'task' | 'event'): void {

    // 1. Validate input
    if (!data || !type) {
      console.error('Invalid data or type provided');
      return;
    }
  
    // 2. Create new tab data with type coercion
    const newTab = { 
      type: type,
      icon: this.typeIconList.find(item => item.type === type)?.icon,
      id: data.id,
      name: data.name
    };
  
    this.activeTabs = this.activeTabs || [];

    const existingIndex = this.activeTabs.findIndex(
      tab => tab.id === newTab.id && tab.type === newTab.type
    );

    if (existingIndex === -1) {
      this.activeTabs = [...this.activeTabs, newTab];
      this.setCurrentTabToLocal(this.activeTabs.length - 1);
    } else {
      this.setCurrentTabToLocal(existingIndex);
    }

    this.setActiveTabsToLocal(this.activeTabs);
    this.tabChangedEvent.next(true);
  }

  public removeConsoleTab(index: number): void {
    this.activeTabs = this.activeTabs.filter((_, i) => i !== index);
    if(this.currentTabIndex == index){
      this.setCurrentTabToLocal(this.currentTabIndex);
    }
    this.setActiveTabsToLocal(this.activeTabs);
    this.tabChangedEvent.next(true);
  }

  public removeConsoleTabById(id: string): void {
    this.activeTabs = this.activeTabs.filter(el => el.id !== id);
    this.setCurrentTabToLocal(this.activeTabs.length - 1);
    this.setActiveTabsToLocal(this.activeTabs);
    this.tabChangedEvent.next(true);
  }

  public changeConsoleTab(index: number): void {
    this.setCurrentTabToLocal(index);
    this.tabChangedEvent.next(true);
  }

}
